module.exports = __webpack_public_path__ + "static/media/syrup pump.a66f3725.JPG";